export var radioTheme = {
  baseStyle: {
    radio: {
      cursor: 'pointer',
      appearance: 'none',
      border: 'basic.dark',
      minWidth: '20px',
      height: '20px',
      borderRadius: 'full',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      _before: {
        content: "''",
        width: '10px',
        height: '10px',
        borderRadius: 'full',
        backgroundColor: 'transparent',
        border: 'transparent'
      },
      _hover: {
        border: 'basic.darker'
      },
      _readOnly: {
        color: 'neutral.darker',
        border: 'basic.dark',
        cursor: 'default'
      },
      _focusVisible: {
        outlineStyle: 'solid',
        outlineColor: 'focus.focus',
        outlineOffset: '2px',
        outlineWidth: '2px'
      },
      _invalid: {
        border: 'input.error'
      },
      _checked: {
        border: 'input.brand',
        _before: {
          backgroundColor: 'brand.main',
          border: 'input.brand'
        },
        _disabled: {
          border: 'input.disabled',
          _before: {
            border: 'input.disabled',
            backgroundColor: 'neutral.light'
          }
        },
        _readOnly: {
          border: 'basic.dark',
          _before: {
            border: 'basic.darker',
            backgroundColor: 'neutral.darker'
          }
        },
        _invalid: {
          border: 'input.error',
          _before: {
            border: 'input.error',
            backgroundColor: 'critical.main'
          }
        }
      },
      _disabled: {
        cursor: 'not-allowed',
        border: 'input.disabled'
      }
    },
    iconIndicator: {
      display: 'flex'
    },
    label: {
      cursor: 'pointer',
      _disabled: {
        cursor: 'not-allowed'
      },
      _readOnly: {
        cursor: 'default'
      }
    }
  }
};
//# sourceMappingURL=Radio.theme.js.map